define('SageDotCom/DataLayer/tealium',['jquery', 'eventManager'], function ($, eventManager) {
    function Tealium() { }

    // invokes the loading of tealium.  as soon as tealium loads, it will
    // consume utag_data and attach itself to window.utag.  this should be called
    // from main.js as part of the Module Loading promise.  This should also _not_
    // be loaded or invoked from experience editor
    Tealium.prototype.initialize = function initialize() {
        window.utag_data = window.utag_data || {};
        // global registrations of analytics and tealium loading should only happen in preview and live mode
        if (typeof define === 'function' && define.amd && !isPageEditor()) {
            // load up tealium and trigger 'tealium-loaded' event in case any components need this
            require(['tealium'], function () {
                eventManager.trigger('tealium-loaded', window.utag_data);
                //once tealium loaded - check the temp queue for events fired before it was loaded
                
            });
        };
    }

    // page level data should be stored on a global utag_data object
    // as soon as tealium loads, this utag_data object is parsed and consumed
    // this function allows components to register page level information before
    // tealium actually is loaded from the initialize() function
    Tealium.prototype.registerPageData = function register(obj) {
        window.utag_data = window.utag_data || {};
        $.extend(window.utag_data, obj); // extend the utag_data object with additional properties
    }

    // Works as registerPageData function except the case when existing property value is array
    // then new value is appended instead of overwriting existing one
    Tealium.prototype.appendPageData = function (data) {
        window.utag_data = window.utag_data || {};

        for (var prop in data) {
            var value = sanitizeValue(data[prop]);

            if (Array.isArray(utag_data[prop])) {
                utag_data[prop] = utag_data[prop].concat(value);
            }
            else {
                utag_data[prop] = value;
            }
        }
    }

    // events are raised as users are interacting with the current page.  each event
    // type has it's own schema that needs to be pushed.  Part of the schema for each
    // event relies upon the HTML attributes of the particular element raising the event.
    // it's up to the caller to generate the necessary event object schema.  this method
    // is purely the interface between SCORE and Tealium
    Tealium.prototype.event = function event(eventObj) {
        // Replace empty values with '(not set)'
        for (prop in eventObj) {
            eventObj[prop] = sanitizeValue(eventObj[prop]);
        }
        window.utag.link(eventObj);
    }

    function sanitizeValue(value) {
        var sanitizedValue;

        if (Array.isArray(value)) {
            sanitizedValue = value.map(function (i) { return i || ''; });
        }
        else {
            sanitizedValue = value || '';
        }

        return sanitizedValue;
    }

    function isPageEditor() {
        if ($("body").hasClass("basic-content-page")) {
            return true;
        }
        if (typeof Sitecore == "undefined") {
            return false;
        }
        if (typeof Sitecore.PageModes == "undefined" || Sitecore.PageModes == null) {
            return false;
        }
        return Sitecore.PageModes.PageEditor != null;
    }

    return new Tealium();
});
